import { PortableText, PortableTextReactComponents } from '@portabletext/react';
import { PortableTextBlock } from '@portabletext/types';
import classNames from 'classnames';

import { linkMarks } from '@utils/serializers';

import styles from './InquiriesInformation.module.css';

export interface Inquiry {
	title: string;
	info: PortableTextBlock[];
}

interface InquiriesInfoProps {
	inquiries: Inquiry[];
}

const components: Partial<PortableTextReactComponents> = {
	block: {
		normal: ({ children }) => <p className="fluid-font-t5">{children}</p>,
	},
	marks: linkMarks,
};

export const InquiriesInformation: React.VFC<InquiriesInfoProps> = ({
	inquiries,
}) => {
	return (
		<section
			className={classNames(styles['media-inquiries'], 'stack-block')}
			data-testid="InquiriesInformation"
		>
			{inquiries.map(({ title, info }) => (
				<div className={classNames(styles['inquiry-block'])} key={title}>
					<h2 className="fluid-font-t5-bold">{title}</h2>
					<PortableText components={components} value={info} />
				</div>
			))}
		</section>
	);
};
